import React from "react"
import { createIcon } from "@chakra-ui/icons"

export const TwitterNew = createIcon({
  displayName: "Twitter",
  viewBox: "0 0 32 32",
  defaultProps: {
    role: "img",
  },
  path: (
    <>
      <title> Twitter icon</title>

      <path
        d="M4.05851 4L13.3246 17.2374L4 28H6.0986L14.2623 18.5772L20.8584 28H28L18.2125 14.018L26.8918 4H24.7932L17.2748 12.6782L11.2001 4H4.05851ZM7.14467 5.6516H10.4255L24.9134 26.3481H21.6325L7.14467 5.6516Z"
        fill="currentColor"
      />
    </>
  ),
})
